// extracted by mini-css-extract-plugin
export default {"EmbedModal":"EmbedModal--yg0E+"};